// Class: motion.actuators.TransformActuator

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function motion_actuators_SimpleActuator() {return require("./../../motion/actuators/SimpleActuator");}
function Reflect() {return require("./../../Reflect");}
function Std() {return require("./../../Std");}
function openfl_display_DisplayObject() {return $import(require("openfl/display/DisplayObject"));}
function openfl_geom_ColorTransform() {return $import(require("openfl/geom/ColorTransform"));}
function motion_actuators_PropertyDetails() {return require("./../../motion/actuators/PropertyDetails");}
function openfl_media_SoundTransform() {return $import(require("openfl/media/SoundTransform"));}

// Constructor

var TransformActuator = function(target,duration,properties) {
	(motion_actuators_SimpleActuator().default).call(this,target,duration,properties);
}

// Meta

TransformActuator.__name__ = ["motion","actuators","TransformActuator"];
TransformActuator.__isInterface__ = false;
TransformActuator.__super__ = (motion_actuators_SimpleActuator().default);
TransformActuator.prototype = $extend((motion_actuators_SimpleActuator().default).prototype, {
	apply: function() {
		this.initialize();
		if(this.endColorTransform != null) {
			var transform = this.getField(this.target,"transform");
			this.setField(transform,"colorTransform",this.endColorTransform);
		}
		if(this.endSoundTransform != null) {
			this.setField(this.target,"soundTransform",this.endSoundTransform);
		}
	},
	initialize: function() {
		if((Reflect().default).hasField(this.properties,"colorValue") && (Std().default)["is"](this.target,(openfl_display_DisplayObject().default))) {
			this.initializeColor();
		}
		if((Reflect().default).hasField(this.properties,"soundVolume") || (Reflect().default).hasField(this.properties,"soundPan")) {
			this.initializeSound();
		}
		this.detailsLength = this.propertyDetails.length;
		this.initialized = true;
	},
	initializeColor: function() {
		this.endColorTransform = new (openfl_geom_ColorTransform().default)();
		var color = this.properties.colorValue;
		var strength = this.properties.colorStrength;
		if(strength < 1) {
			var multiplier;
			var offset;
			if(strength < 0.5) {
				multiplier = 1;
				offset = strength * 2;
			} else {
				multiplier = 1 - (strength - 0.5) * 2;
				offset = 1;
			}
			this.endColorTransform.redMultiplier = multiplier;
			this.endColorTransform.greenMultiplier = multiplier;
			this.endColorTransform.blueMultiplier = multiplier;
			this.endColorTransform.redOffset = offset * (color >> 16 & 255);
			this.endColorTransform.greenOffset = offset * (color >> 8 & 255);
			this.endColorTransform.blueOffset = offset * (color & 255);
		} else {
			this.endColorTransform.redMultiplier = 0;
			this.endColorTransform.greenMultiplier = 0;
			this.endColorTransform.blueMultiplier = 0;
			this.endColorTransform.redOffset = color >> 16 & 255;
			this.endColorTransform.greenOffset = color >> 8 & 255;
			this.endColorTransform.blueOffset = color & 255;
		}
		var propertyNames = ["redMultiplier","greenMultiplier","blueMultiplier","redOffset","greenOffset","blueOffset"];
		if((Reflect().default).hasField(this.properties,"colorAlpha")) {
			this.endColorTransform.alphaMultiplier = this.properties.colorAlpha;
			propertyNames.push("alphaMultiplier");
		} else {
			this.endColorTransform.alphaMultiplier = this.getField(this.target,"alpha");
		}
		var transform = this.getField(this.target,"transform");
		var begin = this.getField(transform,"colorTransform");
		this.tweenColorTransform = new (openfl_geom_ColorTransform().default)();
		var details;
		var start;
		var _g = 0;
		while(_g < propertyNames.length) {
			var propertyName = propertyNames[_g];
			++_g;
			start = this.getField(begin,propertyName);
			details = new (motion_actuators_PropertyDetails().default)(this.tweenColorTransform,propertyName,start,this.getField(this.endColorTransform,propertyName) - start);
			this.propertyDetails.push(details);
		}
	},
	initializeSound: function() {
		if(this.getField(this.target,"soundTransform") == null) {
			this.setField(this.target,"soundTransform",new (openfl_media_SoundTransform().default)());
		}
		var start = this.getField(this.target,"soundTransform");
		this.endSoundTransform = this.getField(this.target,"soundTransform");
		this.tweenSoundTransform = new (openfl_media_SoundTransform().default)();
		if((Reflect().default).hasField(this.properties,"soundVolume")) {
			this.endSoundTransform.volume = this.properties.soundVolume;
			this.propertyDetails.push(new (motion_actuators_PropertyDetails().default)(this.tweenSoundTransform,"volume",start.volume,this.endSoundTransform.volume - start.volume));
		}
		if((Reflect().default).hasField(this.properties,"soundPan")) {
			this.endSoundTransform.pan = this.properties.soundPan;
			this.propertyDetails.push(new (motion_actuators_PropertyDetails().default)(this.tweenSoundTransform,"pan",start.pan,this.endSoundTransform.pan - start.pan));
		}
	},
	update: function(currentTime) {
		(motion_actuators_SimpleActuator().default).prototype.update.call(this,currentTime);
		if(this.endColorTransform != null) {
			var transform = this.getField(this.target,"transform");
			this.setField(transform,"colorTransform",this.tweenColorTransform);
		}
		if(this.endSoundTransform != null) {
			this.setField(this.target,"soundTransform",this.tweenSoundTransform);
		}
	}
});
TransformActuator.prototype.__class__ = TransformActuator.prototype.constructor = $hxClasses["motion.actuators.TransformActuator"] = TransformActuator;

// Init



// Statics




// Export

exports.default = TransformActuator;